import React from 'react';
import { HeroSection } from '../types';
import './Hero.css';

interface HeroProps {
  hero: HeroSection;
}

const Hero: React.FC<HeroProps> = ({ hero }) => {
  return (
    <section className="hero" style={{ backgroundImage: hero.backgroundImage ? `url(${hero.backgroundImage})` : undefined }}>
      <div className="hero-overlay">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-logo">
              <img src="/Peja Peace Forum Logo White.png" alt="Peja Peace Forum Logo" className="hero-logo-img" />
            </div>
            <h2 className="hero-subtitle">{hero.subtitle}</h2>
            <p className="hero-description">{hero.description}</p>
            {hero.ctaText && (
              <a href={hero.ctaLink} className="hero-cta">
                {hero.ctaText}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
